import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyFlagCompositeEntity } from '@nk/data-entities-lib';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CompanyFlagContextContentComponent } from './company-flag-context-content.component';

@Component({
  selector: 'nk-company-flag-context-popover',
  templateUrl: './company-flag-context-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    PopoverModule,
    CompanyFlagContextContentComponent,
  ],
})
export class CompanyFlagContextPopoverComponent {
  public companyFlagComposite = input.required<CompanyFlagCompositeEntity>();
}
